// The debounce function receives our function as a parameter
const debounce = (fn) => {

    // This holds the requestAnimationFrame reference, so we can cancel it if we wish
    let frame;

    // The debounce function returns a new function that can receive a variable number of arguments
    return (...params) => {

        // If the frame variable has been defined, clear it now, and queue for next frame
        if (frame) {
            cancelAnimationFrame(frame);
        }

        // Queue our function call for the next frame
        frame = requestAnimationFrame(() => {

            // Call our function and pass any params we received
            fn(...params);
        });

    }
};

const el = document.getElementById("top");
let scrollPosition = window.scrollY;

// Reads out the scroll position of the #top element and stores it in the data attribute
// so we can use it in our stylesheets
const storeScroll = () => {

    if (scrollPosition < window.scrollY) {
        el.classList.add("is-scrolling-down");
    } else if (scrollPosition > window.scrollY) {
        el.classList.remove("is-scrolling-down");
    }
    scrollPosition = window.scrollY;

    if (window.pageYOffset > el.offsetHeight) {
        el.classList.add("is-scrolled-past");
    } else if (window.pageYOffset < el.offsetHeight){
        el.classList.remove("is-scrolled-past");
    }

    if (window.pageYOffset > 3) {
        el.classList.add("is-scrolled");
    } else if (window.pageYOffset < 1){
        el.classList.remove("is-scrolled");
    }
};

let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if ( ! isIE11) {

    // Listen for new scroll events, here we debounce our `storeScroll` function
    document.addEventListener('scroll', debounce(storeScroll), {passive: true});

    // Update scroll position for first time
    storeScroll();
}